import { ApplicationState } from './types';

export const APPLICATION_SLICE_NAME = 'application';

export const APPLICATION_INITIAL_STATE: ApplicationState = {
  appInitialized: false,
};
